import { useState, useEffect, useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import Card from './Card';
import SearchBox from '../SearchBox/SearchBox';
import TagFilter from '../TagFilter/TagFilter';
import useFetchQuestionnaires from '../../hooks/useFetchQuestionnaires';
import { toast } from 'react-toastify';
import '../../styles/theme-components.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './Swiper.css';

const Cards = () => {
  const { data, loading, error } = useFetchQuestionnaires();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const availableTags = useMemo(() => {
    console.log('Data in availableTags:', data);
    if (!data || !Array.isArray(data)) return [];
    return [...new Set(data.flatMap(item => item.tags || []))].map(tag => {
      return typeof tag === 'string' ? { id: tag, name: tag } : tag;
    });
  }, [data]);

  const filteredData = useMemo(() => {
    console.log('Data in filteredData:', data);
    console.log('Search Term:', searchTerm);
    console.log('Selected Tags:', selectedTags);
    
    if (!data || !Array.isArray(data)) return [];
    return data.filter(item => {
      const matchesSearch = !searchTerm || (item?.title?.toLowerCase() || '').includes(searchTerm.toLowerCase());
      const matchesTags = selectedTags.length === 0 || 
        selectedTags.every(tagId => 
          (item.tags || []).some(tag => 
            (typeof tag === 'string' ? tag : tag.id) === tagId
          )
        );
      console.log('Item:', item, 'matchesSearch:', matchesSearch, 'matchesTags:', matchesTags);
      return matchesSearch && matchesTags;
    });
  }, [data, searchTerm, selectedTags]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <div className="w-3 h-3 theme-loading rounded-full animate-pulse" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center theme-status-error py-8">
        خطا در بارگذاری. لطفا دوباره تلاش کنید
      </div>
    );
  }

  return (
    <>
      <SearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <TagFilter
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
        availableTags={availableTags}
      />
      
      <div className="relative">
        <div className="theme-card container mx-auto px-6 py-12 rounded-3xl">
          {console.log('filteredData length:', filteredData.length)}
          {filteredData.length > 0 ? (
            <div className="swiper-container">
              <Swiper
                modules={[Pagination, Navigation]}
                spaceBetween={32}
                slidesPerView={3}
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }}
                pagination={{
                  clickable: true,
                  el: '.swiper-pagination',
                  renderBullet: function (index, className) {
                    return '<span class="' + className + ' theme-pagination-bullet"></span>';
                  },
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 32
                  }
                }}
                className="mySwiper"
              >
                {filteredData.map(item => (
                  <SwiperSlide key={item.id} className="swiper-slide">
                    <Card
                      id={item.id}
                      image={item.image || '/assets/default-image.jpg'}
                      title={item.title}
                      tags={item.tags}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              
              <div className="swiper-button-prev pointer-events-auto flex items-center justify-center w-10 h-10 rounded-full 
                theme-nav-item transition-all duration-300 group absolute top-1/2 -translate-y-1/2 left-4 z-10">
                <ChevronLeft 
                  className="w-6 h-6 theme-icon stroke-[1.5px] transition-transform group-hover:scale-110 duration-300" 
                />
                <span className="sr-only">قبلی</span>
              </div>
              
              <div className="swiper-button-next pointer-events-auto flex items-center justify-center w-10 h-10 rounded-full 
                theme-nav-item transition-all duration-300 group absolute top-1/2 -translate-y-1/2 right-4 z-10">
                <ChevronRight 
                  className="w-6 h-6 theme-icon stroke-[1.5px] transition-transform group-hover:scale-110 duration-300" 
                />
                <span className="sr-only">بعدی</span>
              </div>
            </div>
          ) : (
            <div className="text-center py-8 theme-text-secondary">
              نتیجه‌ای یافت نشد
            </div>
          )}
        </div>
        
        <div className="swiper-pagination absolute -bottom-8 left-0 right-0" />
      </div>
    </>
  );
};

export default Cards;